import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { BrowserStorageService } from '../../services/browser-storage.service';

const LANG_STORAGE_KEY = 'plp_selected_lang';
const AVAILABLE_LANGS = ['es', 'en', 'pt'];

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private transloco = inject(TranslocoService);
  private browserStorage = inject(BrowserStorageService);

  init(): void {
    const stored = this.browserStorage.getLocalStorageItem(LANG_STORAGE_KEY);
    if (stored && AVAILABLE_LANGS.includes(stored)) {
      this.transloco.setActiveLang(stored);
    }
  }

  setLanguage(lang: string): void {
    const normalized = lang.toLowerCase();
    if (AVAILABLE_LANGS.includes(normalized)) {
      this.transloco.setActiveLang(normalized);
      this.browserStorage.setLocalStorageItem(LANG_STORAGE_KEY, normalized);
    }
  }

  getActiveLanguage(): string {
    return this.transloco.getActiveLang();
  }
}
